export const AnalyticsEvents = Object.freeze({
  CONTACT_US: {
    BANNER: "Contact Us from Banner Clicked",
    FEEDBACK: "Contact Us from Feedback Modal",
    UNLOCK_APP: "Contact Us from Unlock App Modal",
    FEATURE_REQUEST: "Contact Us from Feature Request Modal",
  },
  VIEW_DASHBOARD: {
    START_LOADING: "Start Loading Dashboard",
    FINISH_LOADING: "Finish Loading Dashboard",
    ERROR_LOADING: "Error Loading Dashboard",
  },
});
